
<div>
	<div v-if="blackout" class="slideout-blackout" />
	<transition :name="transition ? 'slideout-container' : 'disable'" appear>
		<div class="sideout-container" :size="size">
			<transition :name="transition ? 'slideout' : 'disable'" mode="out-in">
				<!-- @slot Used to display 'Slideout' Components -->
				<slot />
			</transition>
		</div>
	</transition>
</div>
